// Malaysian
export const ms = {
    weeklyRewards: 'Ganjaran mingguan dalam',
    days: 'hari',
    hours: 'jam',
    minutes: 'min',
    seconds: 'saat',
    authenticating: 'Mengesahkan',
    verifyWallet: 'Sila tunggu semasa kami mengesahkan dompet anda',
    authRequired: 'Pengesahan Diperlukan',
    authFailed: 'Pengesahan gagal. Sila cuba lagi.',
    points: 'Mata',
    rank: 'Kedudukan',
    of: 'daripada',
    players: 'pemain',
    weeklyTopPlayers: 'Pemain Teratas Mingguan',
    thisWeekLeaderboard: 'Papan Pendahulu Minggu Ini',
    rankingsReset: 'Kedudukan diset semula setiap Ahad pada tengah malam UTC',
    yourPoints: 'Mata Anda',
    dailyRewardAvailable: 'Ganjaran Harian Tersedia!',
    nextClaimAvailable: 'Tuntutan Seterusnya Tersedia Dalam:',
    claimDailyReward: 'Tuntut Ganjaran Harian',
    claiming: 'Menuntut...',
    multiplier: 'Pengganda',
    bonusPointsMultiplier: 'Pengganda mata bonus',
    outOf: 'daripada',
    loading: 'Memuatkan...',
    errorLoading: 'Ralat memuatkan',
    noEntries: 'Tiada entri lagi',
    leaderboard: 'Papan Pendahulu',
    tasks: 'Tugas',
    rules: 'Peraturan',
    profile: 'Profil',
    comingSoon: 'Akan datang...',
    completedTasks: 'Tugas Selesai',
    dailyRewardsClaimed: 'Ganjaran Harian Dituntut',
    times: 'kali',
    recentActivity: 'Aktiviti Terkini',
    noRewardsClaimed: 'Belum ada ganjaran dituntut',
    dailyReward: 'Ganjaran Harian',
    howItWorks: 'Cara Ia Berfungsi',
    welcomeMessage:
        'Selamat datang ke Coinomi Rewards! Dapatkan mata dengan melengkapkan pelbagai tugas dan naik dalam papan pendahulu.',
    dailyRewardsTitle: 'Ganjaran Harian',
    dailyRewardsRules: [
        'Tuntut ganjaran harian anda setiap 24 jam',
        'Setiap tuntutan memberikan anda 100 mata',
        'Mata digandakan berdasarkan pengganda anda',
    ],
    multiplierBonusesTitle: 'Bonus Pengganda',
    multiplierBonusesRules: [
        'Mula dengan pengganda 1x',
        'Sambung Telegram untuk bonus +10%',
        'Sahkan emel untuk bonus +10%',
        'Bonus terkumpul untuk ganjaran maksimum',
    ],
    leaderboardTitle: 'Papan Pendahulu',
    leaderboardRules: [
        'Bersaing dengan pemain lain',
        'Kedudukan dikemas kini masa nyata',
        'Pemain teratas mendapat ganjaran khas',
    ],
    boostEarningsTitle: 'Tingkatkan Pendapatan Anda',
    boostEarningsRules: [
        'Selesaikan cabaran untuk mendapat bonus',
        'Sertai komuniti Telegram kami',
        'Kekal aktif untuk memaksimumkan ganjaran anda',
    ],
    challenges: 'Cabaran',
    telegramChallenge: 'Cabaran Telegram',
    emailChallenge: 'Cabaran Emel',
    connectTelegram: 'Sambung dengan Telegram',
    shareEmail: 'Kongsi Emel',
    telegramSuccess: '🎉 Tahniah! Anda kini menerima bonus tetap 10% untuk semua ganjaran!',
    telegramPrompt:
        'Sambungkan akaun Telegram anda untuk mendapat bonus tetap 10% untuk semua ganjaran!',
    emailSuccess: '🎉 Tahniah! Anda kini menerima bonus tetap 10% untuk semua ganjaran!',
    emailPrompt: 'Kongsi emel anda untuk mendapat bonus tetap 10% untuk semua ganjaran!',
    connectEmail: 'Sambung Emel',
    cancel: 'Batal',
    emailPrivacy:
        'Kami hanya akan menggunakan emel anda untuk kemas kini penting dan pemberitahuan ganjaran.',
    connectYourEmail: 'Sambungkan Emel Anda',
    emailBonus: '🎉 Dapatkan bonus tetap 10% untuk semua ganjaran dengan menyambungkan emel anda!',
    enterValidEmail: 'Sila masukkan alamat emel yang sah',
    emailAddress: 'Alamat Emel',
    errorSavingEmail: 'Ralat menyimpan emel. Sila cuba lagi.',
    claimButton: 'Tuntut',
    earnedReward: 'Ganjaran Diperoleh',
    rewardValue: '{{amount}} Mata',
    claimingReward: 'Menuntut...',
    claimSuccess: 'Berjaya menuntut {{amount}} mata!',
    claimError: 'Gagal menuntut ganjaran. Sila cuba lagi.',
    privacyDisclaimer:
        'Coinomi tidak mengumpul data peribadi; sistem pihak ketiga menguruskan mata dan pautan sosial secara selamat.',
    streakBonus: 'Bonus Berturut-turut',
    streakDays: '{{days}}/5 Hari',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Tambahan',
    streakDescription: 'Tuntut 5 hari berturut-turut untuk bonus maksimum',
    streakToday: 'Hari Ini',
    streakMissed: 'Terlepas',
    streakComplete: 'Lengkap',
    streakActive: 'Berturut-turut Aktif',
    streakLost: 'Berturut-turut Hilang',
    streakNext: 'Seterusnya',
    home: 'Utama',
    currentStreak: 'Berturut-turut Semasa',
    totalClaims: 'Jumlah Tuntutan',
    userStats: 'Statistik Anda',
    referrals: 'Rujukan',
    referralProgram: 'Program Rujukan',
    howReferralWorks: 'Cara Rujukan Berfungsi:',
    referralSteps: [
        'Kongsi pautan rujukan anda dengan rakan',
        'Apabila mereka menyertai menggunakan pautan anda, mereka menjadi rujukan anda',
        'Dapatkan mata bonus untuk setiap rujukan aktif',
        'Jejaki rujukan dan pendapatan anda di sini',
    ],
    referralRewards: 'Mata rujukan diberikan:',
    referralBonuses: [
        '100 mata apabila anda menghubungkan seseorang',
        '10% daripada setiap mata yang rujukan perolehi',
    ],
    yourReferralLink: 'Pautan Rujukan Anda',
    copyToClipboard: 'Salin ke papan keratan',
    linkCopied: 'Pautan disalin ke papan keratan!',
    totalReferrals: 'Jumlah Rujukan',
    yourReferralCode: 'Kod Rujukan Anda',
    referralCodeCopied: 'Kod rujukan disalin!',
    editReferralCode: 'Edit Kod Rujukan',
    editReferralCodeInstructions:
        'Pilih kod rujukan baru. Ia mesti sekurang-kurangnya 5 aksara dan boleh mengandungi huruf dan nombor.',
    newReferralCode: 'Kod Rujukan Baru',
    referralCodeRequirements: 'Minimum 5 aksara, huruf dan nombor sahaja',
    updating: 'Mengemas kini...',
    update: 'Kemas kini',
    referralCodeTaken: 'Kod rujukan ini telah digunakan',
    haveReferralCode: 'Ada Kod Rujukan?',
    enterReferralCodePrompt:
        'Jika seseorang merujuk anda, masukkan kod mereka di sini untuk menyambungkan akaun anda.',
    enterReferralCode: 'Masukkan Kod Rujukan',
    enterReferralCodeInstructions: 'Masukkan kod rujukan yang dikongsi dengan anda.',
    referralCode: 'Kod Rujukan',
    referralCodeFormat: 'Huruf dan nombor sahaja',
    submitting: 'Menghantar...',
    submit: 'Hantar',
    enterCode: 'Masukkan Kod',
    pleaseAddtoken: 'Sila tambah parameter token ke URL',
    authenticationError: 'Ralat berlaku semasa pengesahan',
    noUserFound: 'Tiada Pengguna Dijumpai',
    userNotFoundMessage: 'Tidak dapat mencari data pengguna',
    backToHome: 'Kembali ke Utama',
    retry: 'Cuba Lagi',
    baseMultiplier: 'Pengganda Asas',
    telegramBonus: 'Bonus Telegram',
    referralChallenge: 'Cabaran Rujukan',
    referralChallengePrompt:
        'Jemput rakan dan dapatkan mata bonus! Dapatkan 100 mata untuk setiap rujukan tambah 10% daripada pendapatan mereka.',
    startReferring: 'Mula Merujuk',
    referralSuccess:
        '🎉 Tahniah! Anda telah berjaya merujuk pengguna dan sedang mendapat mata bonus!',
    unranked: 'Tidak Ditaraf',
    noPlayersYet: 'Jadilah yang pertama menyertai!',
    shareVia: 'Kongsi melalui',
    shareOn: 'Kongsi di {{network}}',
    shareInviteText:
        '🚀 Saya menjana crypto percuma dengan @CoinomiWallet!\n\nMuat turun Coinomi di coinomi.com/downloads dan masukkan kod rujukan saya {{referralCode}} untuk dapatkan bonus apabila anda sertai #Coinomi Rewards dalam aplikasi.',
    yourStatsThisWeek: 'Statistik anda minggu ini',
    pointsMultiplier: 'Pengganda mata',
    yourRank: 'Kedudukan anda',
    rewards: 'Ganjaran',
    daily: 'Harian',
    weekly: 'Mingguan',
    claimRewards: 'Tuntut ganjaran',
    copy: 'Salin',
    // Twitter Challenge
    twitterChallenge: 'Cabaran Twitter',
    connectTwitter: 'Sambung Twitter',
    twitterSuccess: '🎉 Tahniah! Anda kini menerima bonus tetap 10% untuk semua ganjaran!',
    twitterPrompt:
        'Sambungkan akaun Twitter anda untuk mendapatkan bonus tetap 10% untuk semua ganjaran!',
    pleaseAddUserId: 'Sila tambah parameter userId ke URL',
    emailChallengePrompt: 'Kongsi emel anda untuk mendapat bonus tetap 10% untuk semua ganjaran!',
    emailChallengeSuccess:
        '🎉 Berjaya disambung! Anda kini menerima bonus tetap 10% untuk semua ganjaran!',
    followKoalaWalletChallenge: 'Ikuti @coinomiWallet di Twitter untuk sokong kami!',
    twitterAuthSuccessTitle: 'Twitter Berjaya Disambung!',
    twitterAuthSuccessMessage:
        'Akaun Twitter anda berjaya disambung. Anda kini boleh terus menggunakan aplikasi.',
    continueToApp: 'Teruskan ke Aplikasi',
    twitter_like: 'Suka tweet',
    twitter_retweet: 'Retweet tweet',
    disconnect: 'Putuskan Sambungan',
    followCoinomiWallet: 'Ikuti @coinomiWallet di Twitter untuk sokong kami!',
    connectedBonus: '🎉 Disambung! Anda kini menerima bonus tetap 10% untuk semua ganjaran!',
};
